var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdministration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.795 3.8C1.795 2.131 3.16.778 4.846.778S7.897 2.13 7.897 3.8c0 1.67-1.366 3.022-3.05 3.022-1.686 0-3.052-1.353-3.052-3.022M2.918 8.187l.127-.02a11.5 11.5 0 0 1 3.602 0l.128.02a3.44 3.44 0 0 1 2.917 3.388c0 .91-.744 1.647-1.663 1.647H1.663A1.656 1.656 0 0 1 0 11.575a3.44 3.44 0 0 1 2.918-3.388M9.154.778a.536.536 0 0 0-.539.533c0 .295.241.534.539.534 1.09 0 1.974.875 1.974 1.955s-.884 1.956-1.974 1.956a.536.536 0 0 0-.539.533c0 .295.241.533.539.533 1.685 0 3.051-1.353 3.051-3.022S10.84.778 9.154.778M10.045 8.16a.536.536 0 0 0-.539.534c0 .294.242.533.539.533h.695q.087 0 .173.013a2.37 2.37 0 0 1 2.01 2.335c0 .32-.262.58-.587.58H10.87a.536.536 0 0 0-.539.534c0 .295.241.533.539.533h1.467c.918 0 1.663-.737 1.663-1.647a3.44 3.44 0 0 0-2.918-3.388 2 2 0 0 0-.342-.027z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export { SvgAdministration as ReactComponent };
export default __webpack_public_path__ + "static/media/administration.fd5e44195702b12c351fd8faadd19760.svg";